import Vue from "vue";
import axios from "axios";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;

const getController = self.customSetting.getConstructionMgm;
const postController = self.customSetting.postConstructionMgm;

export default {
  constructionMgmQryFacs: () => {
    return axios.get(`${baseApi}/${getController}/QryFacs`);
  },
  constructionMgmQrySummary: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QrySummary?${params}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  constructionMgmQryWorkTypeDetail: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryWorkTypeDetail?${params}`)
        .then((res) => resolve(res.data.data))
        .catch((err) => reject(err));
    });
  },
  constructionMgmQryMainCheckInCount: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryMainCheckInCount?${params}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  constructionMgmQryMainCheckInCountDetail: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/QryMainCheckInCountDetail`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  constructionMgmQryMainCheckInWorkType: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/QryMainCheckInWorkType`, data)
        .then((res) => resolve(res.data.data))
        .catch((err) => reject(err));
    });
  },
  constructionMgmQryTodayWork: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryTodayWork?${params}`)
        .then((res) => resolve(res.data.data))
        .catch((err) => reject(err));
    });
  },
  constructionMgmQryTodayWorkForQuery: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryTodayWorkForQuery?${params}`)
        .then((res) => resolve(res.data.data))
        .catch((err) => reject(err));
    });
  },
};
